import { Component } from '@angular/core';
import { LiveClassWithCountdownTimerComponent } from '../../../../live-class-with-countdown-timer/live-class-with-countdown-timer.component';

@Component({
  selector: 'lp2-group-class-state-can-sign-up',
  template: `
    <lp2-live-class-state-view-title theme="light" [labelKey]="labelKey">
      <div class="ml-auto mr-auto mt-2 pt-0 mt-sm-0">
        <lp2-live-class-state-view-timer
          theme="light"
          [minutes]="minutes"
          [seconds]="seconds"
        ></lp2-live-class-state-view-timer>
      </div>
    </lp2-live-class-state-view-title>
  `,
})
export class GroupClassStateCanSignUpComponent extends LiveClassWithCountdownTimerComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-can-sign-up.component.ts